export const widgets = {
  hiringEngineers: {
    title: 'Hiring engineers?',
    description:
      'We provide nearshore tech talent to companies from startups to enterprises like Google and Rolls-Royce.',
    talents: [
      {
        name: 'Alejandro D.',
        role: 'Sr. Full-stack Dev.',
        image: {
          url: 'https://assets.bairesdev.com/image/upload/www/static/talent-1_ylgyum',
          alt: 'Alejandro D.',
        },
      },
      {
        name: 'Gustavo A.',
        role: 'Sr. QA Engineer',
        image: {
          url: 'https://assets.bairesdev.com/image/upload/www/static/talent-2_aapbp9',
          alt: 'Gustavo A.',
        },
      },
      {
        name: 'Fiorella G.',
        role: 'Sr. Data Scientist',
        image: {
          url: 'https://assets.bairesdev.com/image/upload/www/static/talent-3_efq9gh',
          alt: 'Fiorella G.',
        },
      },
    ],
    links: [
      {
        label: 'About Us',
        href: 'https://www.bairesdev.com/about/',
      },
      {
        label: 'Our Services',
        href: 'https://www.bairesdev.com/software-development-services/',
      },
      {
        label: 'Our Clients',
        href: 'https://www.bairesdev.com/clients/',
      },
    ],
  },
  relatedServices: {
    title: 'Related services',
  },
  quote: {
    quote:
      'BairesDev assembled a dream team for us and in just a few months our digital offering was completely transformed.',
    author: {
      name: 'VP Product Manager',
      company: 'Rolls-Royce',
      image: 'https://assets.bairesdev.com/image/upload/www/core/joinus_rolls-royce_nca2nu.svg',
    },
    link: {
      label: 'Read Case Study',
      href: 'https://www.bairesdev.com/case-studies/rolls-royce/',
    },
  },
  relatedArticles: {
    title: 'Related articles',
  },
};

export default widgets;
